import { useTheme } from "@mui/material"
import Box from "@mui/material/Box"

import { useMemo, type PropsWithChildren } from "react"

import type { DeviceReportingStatus } from "types/device.types"

interface StatusBoxProps {
  status: DeviceReportingStatus
  variant?: "label" | "tag" | "legend" | "icon"
}

export default function StatusBox({
  children,
  status,
  variant = "label",
}: PropsWithChildren<StatusBoxProps>) {
  const theme = useTheme()

  const styles = useMemo(() => {
    const common = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "0.5rem",
      color: theme.palette.deviceStatus[status].main,
    }

    switch (variant) {
      case "tag":
        return {
          ...common,
          border: "1px solid",
          borderRadius: "5px",
          padding: 0.5,
        }
      case "label":
      case "legend":
      case "icon":
      default:
        return common
    }
  }, [status, theme.palette.deviceStatus, variant])

  return (
    <Box sx={styles} data-testid={`${status}-status-box`}>
      {children}
    </Box>
  )
}
